<template>
  <div>
    <vs-input
      v-if="field.input === 'textfield' || field.input === 'icon'"
      class="w-full"
      :disabled="isReadOnly"
      :value="value || ''"
      @input="$emit('input', $event)"
      :danger="hasError"
      danger-text="Invalid answer"
    />

    <div v-if="isSelectType" class="flex flex-row gap-2 items-start">
      <Combobox
        class="w-full"
        :multiple="isMultiSelect"
        :sortable="field.input === 'sorted_multiselect'"
        :condensedOptions="condensedSelects"
        :error="hasError"
        :options="field.options && field.options.length
          ? field.options.map(option => ({ text: $t(option.label), key: option.key }))
          : (field.values || []).map(item => ({ text: item, key: item }))"
        :disabled="isReadOnly"
        :value="isMultiSelect ? (value ? value.split(',') : []) : (value || '')"
        @input="isMultiSelect ? $emit('input', $event.join(',')) : $emit('input', $event)"
      />
      <SelectActions :manage_link="field.manage_link" @refresh="$emit('refresh')" />
    </div>

    <Tags
      v-if="field.input === 'tags'"
      :value="value ? value.split(',') : []"
      @input="$emit('input', $event.join(','))"
      :danger="hasError"
      danger-text="Invalid answer"
    />

    <div v-if="field.input === 'checkbox'">
      <vs-checkbox
        :disabled="isReadOnly"
        :value="value || ''"
        @input="$emit('input', $event)"
      >{{ subtitleText }}</vs-checkbox>
      <span v-if="hasError" class="con-text-validation span-text-validation-danger">Required</span>
    </div>

    <input-color
      v-if="field.input === 'color'"
      :disabled="isReadOnly"
      :color="value || '#00000000'"
      :required="field.required"
      @input="$emit('input', $event)"
    />

    <vs-input
      v-if="field.input === 'number'"
      :disabled="isReadOnly"
      class="w-full border-grey-light"
      type="number"
      min="0"
      :value="value !== null && value !== undefined ? value : ''"
      @input="$emit('input', isNaN(parseInt($event)) ? null : parseInt($event))"
      :danger="hasError"
      danger-text="Invalid answer"
    />
  </div>
</template>

<script>
import InputColor from "@/modules/Shared/Components/form/InputColor.vue";
import Combobox from "@/modules/Shared/Components/Combobox.vue";
import SelectActions from "@/modules/Shared/Components/form/SelectActions.vue";
import Tags from "@/modules/Shared/Components/form/Tags.vue";

export default {
  name: 'DynamicFormField',
  components: { Combobox, SelectActions, Tags, InputColor },
  props: {
    field: { type: Object, required: true },
    value: { default: null },
    isReadOnly: { type: Boolean, default: false },
    condensedSelects: { type: Boolean, default: false },
  },
  computed: {
    isSelectType() {
      return ['select', 'multiselect', 'sorted_multiselect'].includes(this.field.input)
    },
    isMultiSelect() {
      return this.field.input === 'multiselect' || this.field.input === 'sorted_multiselect'
    },
    hasValue() {
      return !(this.value === null || this.value === undefined || this.value === '')
    },
    hasError() {
      return !this.hasValue && !!this.field.required
    },
    subtitleText() {
      if (!this.field.subtitle) return ''
      if (typeof this.field.subtitle === 'string') return this.$t(this.field.subtitle)
      return this.field.subtitle[this.$store.state.AppActiveUser.language] || ''
    },
  },
}
</script>
